import * as yup from 'yup';
import { isValidCpf } from '~/utils/isValidCpf';
import addressSchema from '../../step2/validation';

const insuredSchema = yup.object({
  socialName: yup
    .string()
    .max(64, 'Insira no máximo 64 caracteres')
    .matches(/^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]*$/, 'Insira apenas letras'),
  name: yup
    .string()
    .min(4, 'Insira no mínimo 4 caracteres')
    .max(64, 'Insira no máximo 64 caracteres')
    .matches(/^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]+$/, 'Insira apenas letras')
    .required()
    .test('test-name-complete-length', 'Digite o nome completo, este parece incompleto.', (value) => {
      if (!value) return false;
      return (
        value
          .trim()
          .split(' ')
          .filter((word) => word.length > 0).length > 1
      );
    }),
  email: yup.string().email('Email inválido').required('Email é obrigatório'),
  confirm_email: yup
    .string()
    .required('Confirmação de e-mail é obrigatória')
    .oneOf([yup.ref('email')], 'O e-mail de confirmação deve ser igual ao e-mail acima.'),
  mobile_phone: yup
    .string()
    .min(10, 'Número inválido')
    .required('Celular é obrigatório')
    .test('test-phone-complete-length', 'Digite o celular completo, este parece incompleto.', (value) => {
      if (!value) return false;
      return value.replace(/\D/g, '').length >= 11;
    }),
  document: yup
    .string()
    .required('CPF é obrigatório')
    .test('test-valid-cpf', 'Digite um cpf válido.', (value) => (value ? isValidCpf(value) : false)),
  birthDate: yup
    .string()
    .required('Insira uma data de nascimento válida')
    .test('test-valid-date', 'Insira uma data de nascimento válida', (value) => {
      const cleanDate = value?.split('T')[0];
      if (!cleanDate) return false;

      const isUnderAge = (date: Date) => {
        const diffMs = Date.now() - date.getTime();
        const ageDt = new Date(diffMs);
        return Math.abs(ageDt.getUTCFullYear() - 1970) < 18;
      };

      const year = new Date(cleanDate).getFullYear();
      const actualYear = new Date().getFullYear();
      return year >= 1900 && year <= actualYear && !isUnderAge(new Date(cleanDate));
    }),
  password: yup
    .string()
    .required('Senha é obrigatória')
    .min(8, 'A senha precisa ter no mínimo 8 caracteres')
    .matches(/[A-Za-zÀ-ÿ]/, 'A senha precisa ter ao menos uma letra')
    .matches(/\d/, 'A senha precisa ter ao menos um número')
    .matches(/[^A-Za-zÀ-ÿ0-9]/, 'A senha precisa ter ao menos um símbolo (ex.: ! @ # $)'),
  confirm_password: yup
    .string()
    .required('Confirmação de senha é obrigatória')
    .oneOf([yup.ref('password')], 'As senhas digitadas não coincidem. Verifique se você digitou a mesma.')
});

export type Step1FormValues = yup.InferType<typeof insuredSchema> &
  yup.InferType<typeof addressSchema> & {
    confirm_password: string;
    password: string;
  };

export const step1CombinedSchema = insuredSchema.concat(addressSchema);
